<template>
  <v-container fluid grid-list-lg class="pa-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs show-arrows centered height="40">
          <v-tabs-slider color="#ff5a10"></v-tabs-slider>
            <v-tab
              v-for="kitchenLine in kitchenLines"
              :key="`line-${kitchenLine.id}-${kitchenLine.kitchen_line_id}`"
              @click="changeLine(kitchenLine)"
            >
              {{ kitchenLine.name }}
            </v-tab>
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
.theme--dark .tabs-container .v-tabs__bar,
.theme--dark .tabs-container .v-card {
  background-color: #223345 !important;
}

.theme--light .tabs-container .v-card,
.theme--light.v-tabs__bar {
  background-color: whitesmoke !important;
}
</style>

<script>
export default {
  name: "KitchenLine",
  data() {
    return {
      kitchenLines: [],
      storeId: 0,
      selected: {},
      lineRestricted: JSON.parse(localStorage.getItem("isLineRestricted")),
    };
  },
  methods: {
    getKitchenLines() {
      let url = this.$apiURL + "store/" + this.storeId + "/kitchenLines";
      this.$http.get(url).then(function (resp) {
        this.kitchenLines = resp.body.lines || [];
        this.kitchenLines.unshift(this.chefMode());
      });
    },
    chefMode() {
      return {
        id: 0,
        kitchen_line_id: 0,
        kitchen_line_name: "Chef",
        name: "Chef",
        default: true,
      };
    },
    changeLine(line) {
      this.selected = {
        id: line.id,
        kitchen_line_id: line.kitchen_line_id,
        kitchen_line_name: line.kitchen_line_name,
        name: line.name,
      };
      this.$store.dispatch("setKitchenLine", {
        kl: this.selected,
      });
    },
    init() {
      this.storeId = localStorage.getItem("storeId");
      this.getKitchenLines();
      if (this.lineRestricted) {
      }
      let line = localStorage.getItem("kitchenLine");
      if (line) {
        this.selected = JSON.parse(line);
        return;
      }
    },
  },
  computed: {
    kitchenLine() {
      let line = JSON.parse(localStorage.getItem("kitchenLine"));

      if (line) return line.name;
      else "";
    },
  },
  created() {
    this.init();
  },
};
</script>